import { Component } from "react";
import React from "react";

import "./verticalLineStyle.scss";

class VerticalLine extends Component {
  render() {
    const { height, color, width } = this.props;
    return (
      <div
        className={`vertical--line ${height ? "" : "fit--content"} `}
        style={{
          height: `${height ? height : ""}px`,
          borderColor: `${color ? color : "#ff4834"}`,
          borderWidth: `${width ? width : "3"}px`,
        }}
      ></div>
    );
  }
}

export default VerticalLine;
